import React, { useState } from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";

const AddToCart = () => {
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: "RAJSHREE 100",
      ticketNumbers: ["B/100001", "B/100005"],
      price: 100,
      quantity: 2,
    },
    {
      id: 2,
      name: "LUCKY STAR",
      ticketNumbers: ["B/200003"],
      price: 50,
      quantity: 1,
    },
  ]);

  const incrementQty = (id) => {
    setCartItems(prev =>
      prev.map(item => item.id === id ? { ...item, quantity: item.quantity + 1 } : item)
    );
  };

  const decrementQty = (id) => {
    setCartItems(prev =>
      prev.map(item => item.id === id ? { ...item, quantity: Math.max(1, item.quantity - 1) } : item)
    );
  };

  const totalAmount = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);

  return (
    <>
    <Header />
    <div className="addtocart-container">
      <h1>My Cart</h1>

      <div className="cart-items">
        {cartItems.map(item => (
          <div className="cart-card" key={item.id}>
            <div className="cart-card-content">
              <h2>{item.name}</h2>
              <p>Tickets: {item.ticketNumbers.join(", ")}</p>

              <div className="price-qty">
                <div className="price">
                  <CurrencyRupeeIcon /> {item.price} / ticket
                </div>
                <div className="quantity">
                  <button onClick={() => decrementQty(item.id)}>-</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => incrementQty(item.id)}>+</button>
                </div>
                <div className="total">
                  Total: <CurrencyRupeeIcon /> {item.price * item.quantity}
                </div>
              </div>

              <div className="cart-buttons">
                <button className="remove">Remove</button>
                <button className="buy">Buy Now</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="cart-summary">
        <h2>Total: <CurrencyRupeeIcon /> {totalAmount}</h2>
        <div className="summary-buttons">
          <button className="continue">Continue Shopping</button>
          <button className="checkout">Checkout</button>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default AddToCart;
